import actions from "@/store/actions";
import * as ACTIONS from "@/config/constants/action-types";
import * as MUTATIONS from "@/config/constants/mutation-types";
import * as END_POINTS from "@/config/constants/end-points";
import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  CLIENTE_EXISTENTE,
  INDIVIDUO_NEGATIVO_EMPRENDEDOR
} from "@/config/constants/step-constants";
import { step4 } from "@/config/constants/steps";

jest.mock("vue", () => ({
  $log: {
    info: jest.fn(),
    debug: jest.fn(),
    error: jest.fn()
  }
}));

jest.mock("@/router", () => ({
  push: jest.fn()
}));

jest.mock("@/api/index", () => ({
  request: jest.fn()
}));

describe("actions", () => {
  let commit, dispatch, state, context;

  beforeEach(() => {
    commit = jest.fn();
    dispatch = jest.fn();
    state = {
      mock: false,
      paso1: { cuit: "20-12345678-9" } // Se añade el estado para evitar errores
    };

    context = { commit, dispatch, state };
    jest.useFakeTimers();
  });

  afterEach(() => {
    jest.useRealTimers();
  });

  it("DO_ROUTE", () => {
    actions[ACTIONS.DO_ROUTE]({ commit }, "payload");
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_ROUTE, "payload");
    jest.runAllTimers();
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
  });

  it("DO_ROUTE_PUSH", () => {
    actions[ACTIONS.DO_ROUTE_PUSH]({ dispatch }, "ruta");
    expect(require("@/router").push).toHaveBeenCalledWith("ruta");
  });

  it("DO_ROUTE_PUSH -> ERROR TECNICO", () => {
    actions[ACTIONS.DO_ROUTE_PUSH]({ dispatch }, undefined);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_IS_LOADING", () => {
    actions[ACTIONS.DO_IS_LOADING]({ commit }, "payload");
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, "payload");
  });

  it("DO_REQUEST_API", async () => {
    const actionPayload = {
      endPoint: "endPoint",
      payload: "payload",
      doSuccess: "doSuccess",
      doError: "doError"
    };
    require("@/api/index").request.mockResolvedValue({ data: "data" });
    await actions[ACTIONS.DO_REQUEST_API]({ state, dispatch }, actionPayload);
    expect(require("@/api/index").request).toHaveBeenCalledWith({
      endPoint: "endPoint",
      body: "payload",
      mock: false
    });
    expect(dispatch).toHaveBeenCalledWith("doSuccess", "data");
  });

  // it('DO_REQUEST_API -> dispatches "doError" action when request fails', async () =>{
  //   const actionPayload = {
  //     endPoint: "endPoint",
  //     payload: "payload",
  //     doError: "doError"
  //   };

  //   const error = new Error('Request failed');
  //   require("@/api/index").request.mockRejectedValue( error );

  //   await actions[ACTIONS.DO_REQUEST_API]({ state, dispatch }, actionPayload);

  //   expect(require("@/api/index").request).toHaveBeenCalledWith({
  //     endPoint: "endPoint",
  //     body: "payload",
  //     mock: false
  //   });

  //   expect(dispatch).toHaveBeenCalledWith("doError", error);
  // });

  // it('dispatches "DO_PASO_ERROR" action when request fails and doError is undefined', async () => {
  //   const actionPayload = {
  //     endPoint: "endPoint",
  //     payload: "payload"
  //   };

  //   const error = new Error('Request failed');
  //   require("@/api/index").request.mockImplementation(() => Promise.reject(error) );

  //   await actions[ACTIONS.DO_REQUEST_API]({ state, dispatch }, actionPayload);

  //   expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_PASO_ERROR, error);
  // });

  it("DO_PASO1", () => {
    const payload = {
      nombre: "John",
      apellido: "Doe",
      phone: { area: "123", numero: "4567890" },
      cuit: "20-12345678-9"
    };

    actions[ACTIONS.DO_PASO1](context, payload);

    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_1, payload);
  });

  it("DO_PASO1_SUCCESS", () => {
    const payload = {};
    const getters = {
      getPaso1: jest.fn().mockReturnValue({
        esPF: true
      })
    };
    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, dispatch, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_1_SUCCESS, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_ROUTE_PUSH, "paso2");
  });

  it("DO_PASO1_SUCCESS with status ERROR and respuesta ES_NEGATIVO INDIVIDUO_NEGATIVO", () => {
    const payload = {
      status: "ERROR",
      respuesta: "ES_NEGATIVO"
    };
    const getters = {
      getPaso1: jest.fn().mockReturnValue({
        esPF: false
      })
    };
    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO
    );
  });

  it("DO_PASO1_SUCCESS with status ERROR and respuesta ES_NEGATIVO INDIVIDUO_NEGATIVO_EMPRENDEDOR", () => {
    const payload = {
      status: "ERROR",
      respuesta: "ES_NEGATIVO"
    };
    const getters = {
      getPaso1: jest.fn().mockReturnValue({
        esPF: true
      })
    };
    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO_EMPRENDEDOR
    );
  });

  it("DO_PASO1_SUCCESS with status ERROR", () => {
    const payload = {
      status: "ERROR"
    };
    const getters = {
      getPaso1: jest.fn().mockReturnValue({
        esPF: true
      })
    };

    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_PASO2", () => {
    actions[ACTIONS.DO_PASO2]({ commit, dispatch, state }, "payload");

    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_2, "payload");
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_ROUTE_PUSH, "paso3");
  });

  it("DO_PASO3", () => {
    actions[ACTIONS.DO_PASO3]({ commit, dispatch }, "payload");

    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_3, "payload");
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_ROUTE_PUSH, "paso4");
  });

  describe("DO_PASO4 tests", () => {
    // Función auxiliar para generar los getters
    const createGetters = (overrides = {}) => ({
      getOrigen: jest.fn().mockReturnValue("test origen"),
      getPaso1: jest.fn().mockReturnValue({
        cuit: "20304050607",
        razonSocial: "",
        esPF: false,
        ...overrides.getPaso1
      }),
      getPaso2: jest.fn().mockReturnValue({
        tipoActividad: "",
        rangoFacturacion: "",
        tipoDeCobro: "",
        lugarDeCobro: "",
        volumenDeOperaciones: "",
        ...overrides.getPaso2
      }),
      getPaso3: jest.fn().mockReturnValue({
        nombre: "",
        apellido: "",
        phone: { area: "", numero: "" },
        email: "",
        horario: "",
        cargoArea: "",
        ...overrides.getPaso3
      }),
      getPaso4: jest.fn().mockReturnValue({
        numSucursal: "1234",
        financiacion: false,
        cobrosPagos: false,
        seguroComercio: false,
        dirSucursal: "",
        ...overrides.getPaso4
      })
    });

    it("DO_PASO4 with esPF false", () => {
      const getters = createGetters(); // getters por defecto
      actions[ACTIONS.DO_PASO4]({ commit, dispatch, getters }, "payload");

      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_4, "payload");
      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.GUARDAR_DATOS_CONTACTO,
        doSuccess: ACTIONS.DO_PASO4_SUCCESS,
        payload: {
          cuit: "20304050607",
          razonSocial: "",
          tipoDeActividad: "",
          rangoFacturacion: "",
          nombre: "",
          apellido: "",
          telefono: "",
          email: "",
          sucursal: "1234",
          cargo: "",
          horarioContacto: "",
          lineasDeFinanciacion: false,
          cobrosYPagos: false,
          seguroComercio: false,
          origen: "test origen",
          esEmprendedor: false,
          dirSucursal: "",
          tipoDeCobro: " ",
          lugarDeCobro: " ",
          volumenDeOperaciones: " "
        }
      });
    });

    it("DO_PASO4 with esPF true", () => {
      const getters = createGetters({
        getPaso1: { esPF: true },
        getPaso2: {
          tipoDeCobro: "Presencial",
          lugarDeCobro: "En un lugar fijo",
          volumenDeOperaciones: "Menos de 20 por día"
        },
        getPaso4: {
          seguroComercio: true
        }
      }); // Sobrescribimos
      actions[ACTIONS.DO_PASO4]({ commit, dispatch, getters }, "payload");

      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_4, "payload");
      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.GUARDAR_DATOS_CONTACTO,
        doSuccess: ACTIONS.DO_PASO4_SUCCESS,
        payload: {
          cuit: "20304050607",
          razonSocial: "",
          tipoDeActividad: "",
          rangoFacturacion: "",
          nombre: "",
          apellido: "",
          telefono: "",
          email: "",
          sucursal: "1234",
          cargo: "",
          horarioContacto: "",
          lineasDeFinanciacion: false,
          cobrosYPagos: false,
          seguroComercio: true, // Cambiado a true
          origen: "test origen",
          esEmprendedor: true, // Cambiado a true
          dirSucursal: "",
          tipoDeCobro: "Presencial",
          lugarDeCobro: "En un lugar fijo",
          volumenDeOperaciones: "Menos de 20 por día"
        }
      });
    });
  });

  it("DO_PASO4_SUCCESS", () => {
    const dispatch = jest.fn();
    const createGetters = (overrides = {}) => ({
      getPaso1: jest.fn().mockReturnValue({
        esPF: false,
        ...overrides.getPaso1
      })
    });

    let getters = createGetters();
    // Test case when status is ERROR
    let payload = { status: "ERROR" };
    actions[ACTIONS.DO_PASO4_SUCCESS]({ dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, step4["ERROR"]);

    // Test case when status is ERROR, respuesta is CLIENTE_EXISTENTE and esPF is false
    payload = { status: "ERROR", respuesta: "CLIENTE_EXISTENTE" };
    actions[ACTIONS.DO_PASO4_SUCCESS]({ dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      CLIENTE_EXISTENTE
    );

    // Test case when status is ERROR, respuesta is CLIENTE_EXISTENTE and esPF is true
    getters = createGetters({ getPaso1: { esPF: true } });
    actions[ACTIONS.DO_PASO4_SUCCESS]({ dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO_EMPRENDEDOR
    );

    // Test case when status is not ERROR
    payload = { status: "SUCCESS" };
    actions[ACTIONS.DO_PASO4_SUCCESS]({ dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_ROUTE_PUSH,
      step4["GRACIAS"]
    );
  });

  it("DO_PASO_ERROR", () => {
    const payload = "error";
    actions[ACTIONS.DO_PASO_ERROR]({ dispatch }, payload);
    expect(require("vue").$log.error).toHaveBeenCalledWith(payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_MENSAJE", () => {
    const payload = "message";
    actions[ACTIONS.DO_MENSAJE]({ dispatch }, payload);
    expect(require("@/router").push).toHaveBeenCalledWith({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  });

  it("DO_MENSAJE with no payload", () => {
    actions[ACTIONS.DO_MENSAJE]({ dispatch });
    expect(require("@/router").push).toHaveBeenCalledWith({
      name: "mensaje",
      params: {
        mje: ERROR_TECNICO
      }
    });
  });

  it("DO_CLICK_TRACKING with null trackClickElement", () => {
    const payload = "payload";
    const state = { trackClickElement: null };
    actions[ACTIONS.DO_CLICK_TRACKING]({ state, commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ADOBE_APP_STARTED, payload);
  });

  it("DO_CLICK_TRACKING with non-null trackClickElement", () => {
    const payload = "payload";
    const state = { trackClickElement: "non-null value" };
    actions[ACTIONS.DO_CLICK_TRACKING]({ state, commit }, payload);
    expect(commit).not.toHaveBeenCalled();
  });

  it("DO_MOCK", () => {
    const payload = "payload";
    actions[ACTIONS.DO_MOCK]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_MOCK, payload);
  });

  it("DO_NOTIFICATION_TOAST", () => {
    const payload = { type: "info", message: "message" };
    actions[ACTIONS.DO_NOTIFICATION_TOAST]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NOTIFICATION_TOAST,
      payload
    );
    jest.runAllTimers();
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
  });

  it("DO_NOTIFICATION_TOAST_RESET", () => {
    actions[ACTIONS.DO_NOTIFICATION_TOAST_RESET]({ commit });
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: ""
    });
  });
});
